import moment from "moment";
// 引用图片
import groupIcon1 from "../../../assets/img/diagnostic/group_icon1.png";
import electricalLossResult from "../../../assets/img/diagnostic/模块间电流稳定性.png";
import groupIcon2 from "../../../assets/img/diagnostic/group_icon2.png";
import stubResult from "../../../assets/img/diagnostic/设备状态.png";
import groupIcon3 from "../../../assets/img/diagnostic/group_icon3.png";
import stubIntactResult from "../../../assets/img/diagnostic/设备完好率.png";
import chargeSuccessResult from "../../../assets/img/diagnostic/充电成功率.png";
import startSuccessResult from "../../../assets/img/diagnostic/充电启动成功率.png";
import groupIcon4 from "../../../assets/img/diagnostic/group_icon4.png";
import groupIcon5 from "../../../assets/img/diagnostic/group_icon5.png";
import faultReportrdResult from "../../../assets/img/diagnostic/故障情况.png";
import groupIcon6 from "../../../assets/img/diagnostic/group_icon6.png";
import moduleWorkTempResult from "../../../assets/img/diagnostic/模块正常工作温度.png";
import moduleEnvTempResult from "../../../assets/img/diagnostic/模块使用环境检测.png";
import moduleUseTempResult from "../../../assets/img/diagnostic/模块间使用温度稳定性.png";
import moduleCfgResult from "../../../assets/img/diagnostic/模块配置.png";
/**
 * 诊断管理配置项
 */

// 页面状态配置项
const DIA_TYPE = [
  {
    text: "正在检测中，请耐心等待结果...",
    info: "检测结束后，可查看各项结果和参考定位问题。",
    type: 0,
    btnText: "取消检测",
  },
  {
    text: "检测被中断，建议您重新检测",
    info: null,
    type: 1,
    btnText: "重新检测",
  },
  {
    text: "本次检测已完成，暂未发现异常。",
    info: null,
    type: 2,
    btnText: "重新检测",
  },
  {
    text: "检测结束，发现一些异常，请查看结果！",
    info: null,
    type: 3,
    btnText: "重新检测",
  },
  {
    text: "设备离线，无法检测",
    info: null,
    type: 4,
    btnText: "重新检测",
  },
];

/**         初始状态  检测中   检测成功  检测失败  检测无数据uncheck
 * status:  waiting, loading, success， error, uncheck
 *
 */

/**
 * btnHandler， 错误时跳转的页面，接收选中电站/设备， 和onAdd方法，在此函数构造跳转目标页面的方法
 */
const STATION_MODULE = [
  {
    name: "用电数据检测",
    completeCnt: 0,
    errorCnt: 0,
    icon: groupIcon1,
    children: [
      {
        name: "电损",
        status: "waiting",
        msg: "未检测",
        key: "electricalLossResult",
        icon: electricalLossResult,
        btnHandler: (record, addTab) => {
          addTab(
            {
              key: "030103",
              titleText: "电损",
            },
            {
              stubGroupName: record.name,
              date: [moment().subtract(7, "d"), moment(), moment().subtract(1, "d")],
            },
          );
        },
      },
    ],
  },
  {
    name: "设备运行检测",
    completeCnt: 0,
    errorCnt: 0,
    icon: groupIcon2,
    children: [
      {
        name: "设备状态",
        status: "waiting",
        msg: "未检测",
        key: "stubResult",
        icon: stubResult,
        btnHandler: (record, addTab) => {
          addTab(
            {
              key: ["0102", "0110", "0107"][record.redirect - 1],
              titleText: ["公充设备查询", "墙盒设备查询", "地锁查询"][record.redirect - 1],
            },
            {
              StubName: record.name,
            },
          );
        },
      },
    ],
  },
];

// 设备配置项
const EQU_MODULE = [
  {
    name: "数据指标检测",
    completeCnt: 0,
    errorCnt: 0,
    icon: groupIcon3,
    children: [
      {
        name: "设备完好率",
        status: "waiting",
        msg: "未检测",
        key: "stubIntactResult",
        icon: stubIntactResult,
        btnHandler: (record, addTab) => {
          addTab(
            {
              key: "stubIntactDetail",
              titleText: "设备完好率趋势",
            },
            {
              stubId: record.key,
            },
          );
        },
      },
      {
        name: "充电成功率",
        status: "waiting",
        msg: "未检测",
        key: "chargeSuccessResult",
        icon: chargeSuccessResult,
        btnHandler: (record, addTab) => {
          addTab(
            {
              key: "equChargeSuccessDetail",
              titleText: "设备充电成功率",
            },
            {
              equipmentInfo: {
                stubId: record.key,
              },
            },
          );
        },
      },
      {
        name: "充电启动成功率",
        status: "waiting",
        msg: "未检测",
        key: "startSuccessResult",
        icon: startSuccessResult,
        btnHandler: (record, addTab) => {
          addTab(
            {
              key: "equChargeSuccessDetail",
              titleText: "设备充电成功率",
            },
            {
              equipmentInfo: {
                stubId: record.key,
              },
            },
          );
        },
      },
    ],
  },
  {
    name: "运行状态分析",
    completeCnt: 0,
    errorCnt: 0,
    icon: groupIcon4,
    children: [
      {
        name: "设备状态",
        status: "waiting",
        msg: "未检测",
        key: "stubStatusResult",
        icon: stubResult,
        btnHandler: (record, addTab) => {
          addTab(
            {
              key: ["0102", "0110", "0107"][record.redirect - 1],
              titleText: ["公充设备查询", "墙盒设备查询", "地锁查询"][record.redirect - 1],
            },
            {
              stubId: record.key,
            },
          );
        },
      },
    ],
  },
  {
    name: "设备质量分析",
    completeCnt: 0,
    errorCnt: 0,
    icon: groupIcon5,
    children: [
      {
        name: "故障情况",
        status: "waiting",
        msg: "未检测",
        key: "faultReportrdResult",
        icon: faultReportrdResult,
        btnHandler: (record, addTab) => {
          addTab(
            {
              key: ["0102", "0110", "0107"][record.redirect - 1],
              titleText: ["公充设备查询", "墙盒设备查询", "地锁查询"][record.redirect - 1],
            },
            {
              stubId: record.key,
              date: [moment().subtract(6, "d"), moment()],
            },
          );
        },
      },
    ],
  },
  {
    name: "充电过程分析",
    completeCnt: 0,
    errorCnt: 0,
    icon: groupIcon6,
    children: [
      {
        name: "模块间电流稳定性检测",
        status: "waiting",
        msg: "未检测",
        key: "moduleCurrentResult",
        icon: electricalLossResult,
        btnHandler: (record, addTab) => {
          addTab(
            {
              key: "0402",
              titleText: "平台事件监控列表",
            },
            {
              eventName: "模块电流不均衡告警",
              date: [moment().subtract(6, "d"), moment()],
            },
          );
        },
      },
      {
        name: "模块工作温度检测",
        status: "waiting",
        msg: "未检测",
        key: "moduleWorkTempResult",
        icon: moduleWorkTempResult,
        btnHandler: (record, addTab) => {
          addTab(
            {
              key: "0402",
              titleText: "平台事件监控列表",
            },
            {
              eventName: "模块高温限流告警",
              date: [moment().subtract(6, "d"), moment()],
            },
          );
        },
      },
      {
        name: "模块温度与环温对比检测",
        status: "waiting",
        msg: "未检测",
        key: "moduleEnvTempResult",
        icon: moduleEnvTempResult,
        btnHandler: (record, addTab) => {
          addTab(
            {
              key: "0402",
              titleText: "平台事件监控列表",
            },
            {
              eventName: "模块环温相差告警",
              date: [moment().subtract(6, "d"), moment()],
            },
          );
        },
      },
      {
        name: "模块温度稳定性检测",
        status: "waiting",
        msg: "未检测",
        key: "moduleUseTempResult",
        icon: moduleUseTempResult,
        btnHandler: (record, addTab) => {
          addTab(
            {
              key: "0402",
              titleText: "平台事件监控列表",
            },
            {
              eventName: "模块温度不均衡告警",
              date: [moment().subtract(6, "d"), moment()],
            },
          );
        },
      },
      {
        name: "模块个数检测",
        status: "waiting",
        msg: "未检测",
        key: "moduleCfgResult",
        icon: moduleCfgResult,
        btnHandler: (record, addTab) => {
          addTab(
            {
              key: "0402",
              titleText: "平台事件监控列表",
            },
            {
              eventName: "模块配置异常告警",
              date: [moment().subtract(6, "d"), moment()],
            },
          );
        },
      },
    ],
  },
];

export { STATION_MODULE, EQU_MODULE, DIA_TYPE };



// WEBPACK FOOTER //
// ./src/AntD/pages/diagnosticManage/diagnosticAnalysis/config.js